import { Text } from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDisplayDate } from "../../../../../common/formatting/useDisplayDate";

interface Period {
  validFrom: string;
  validTo: string;
}

type Draft = { validFrom: string | null; validTo: string | null };

export const useValidityPeriod = (saved: Period | null, save: (period: Period) => void) => {
  const [draft, setDraft] = useState<Draft | null>(null);
  const validFrom = draft ? draft.validFrom : saved?.validFrom ?? null;
  const validTo = draft ? draft.validTo : saved?.validTo ?? null;

  const setValidity = (next: Partial<Draft>) => {
    const merged: Draft = { validFrom, validTo, ...next };
    setDraft(merged);
    if (merged.validFrom && merged.validTo) save({ validFrom: merged.validFrom, validTo: merged.validTo });
  };

  const keepsSavedPeriod = saved != null && draft != null && (!draft.validFrom || !draft.validTo);
  return { validFrom, validTo, setValidity, keepsSavedPeriod };
};

export const SavedPeriodStays = ({ saved }: { saved: Period }) => {
  const { t } = useTranslation();
  const displayDate = useDisplayDate();
  return (
    <Text fontSize="sm" color="smWarning" mt="3" role="status">
      {t("Choose both dates to save the period. Until then, the saved period stays: {{from}} – {{to}}.", {
        from: displayDate(saved.validFrom),
        to: displayDate(saved.validTo),
      })}
    </Text>
  );
};
